<template>
  <div v-if="list.length">
    <div v-for="(item, index) in list" class="system-notice" :key="index" @click="openNoticePage(item)">
      <div class="system-notice-div">
        <div class="system-notice-title" :title="item.title">{{ item.title }}</div>
        <div class="system-notice-time">
          {{ item.createdDate ? moment(item.createdDate).format('YYYY-MM-DD') : '-' }}
        </div>
      </div>
    </div>
  </div>
  <div class="noData" v-else>
    <img src="@/config/images/nodata.png" height="134" width="134" />
    <br />
    <span>暂无数据</span>
  </div>
</template>
<script>
import moment from 'moment'
export default {
	name: "InfoList",
  props: {
    list: Array
  },
  data() {
    return {
      moment,
    }
  },
  methods: {
    openNoticePage(item) {
      this.$emit('detail', item)
    }
  }
};
</script>

<style lang="less" scoped>
.noData {
  text-align: center;
}
.system-notice {
  height: 40px;
  width: 100%;
  cursor: pointer;
  :hover {
    background-color: #e5efec;
    color: #0E8FA5;
  }
  .system-notice-div {
    display: flex;
    justify-content: space-between;
    line-height: 40px;
  }
  .system-notice-title {
    width: calc(100% - 100px);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .system-notice-time {
    width: 100px;
    text-align: center;
  }
}
</style>

